import { NgModule } from '@angular/core';
import { PdvEffects } from './effects/pdv.effect';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PDV_FEATURE } from './actions/pdv.actions';
import { pdvReducers } from './reducers/pdv.reducer';
import { EVENT_FEATURE } from './actions/event.actions';
import { eventReducers } from './reducers/event.reducer';
import { EventEffects } from './effects/event.effect';

@NgModule({
  imports: [
    StoreModule.forFeature(PDV_FEATURE, pdvReducers),
    StoreModule.forFeature(EVENT_FEATURE, eventReducers),
    EffectsModule.forFeature([ PdvEffects ]),
    EffectsModule.forFeature([ EventEffects ]),
  ],
})
export class PdvStoreModule {}
